import { render, staticRenderFns } from "./RatingStars.vue?vue&type=template&id=2ea2f640&scoped=true"
import script from "./RatingStars.vue?vue&type=script&lang=js"
export * from "./RatingStars.vue?vue&type=script&lang=js"
import style0 from "./RatingStars.vue?vue&type=style&index=0&id=2ea2f640&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea2f640",
  null
  
)

export default component.exports